/* eslint-disable @typescript-eslint/no-explicit-any */
import { getRefreshToken } from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.NX_API_URL;

const useMenuScrappingSocket = ({
  triggerScrapping,
  setModalLoaderProgress,
  setLoadProgress,
  onScrapeFail,
}: // onImportFail,
// onImportSuccess,
{
  triggerScrapping: () => void;
  setModalLoaderProgress: Dispatch<SetStateAction<boolean>>;
  setLoadProgress: Dispatch<SetStateAction<number>>;
  onScrapeFail: () => void;
  // onImportFail: () => void;
  // onImportSuccess: () => void;
}) => {
  const socketRef = useRef<any>(null);
  const refreshToken = getRefreshToken();

  useEffect(() => {
    if (!refreshToken) return;

    const socket = io(SOCKET_URL, {
      path: '/brand-template',
      transports: ['websocket'],
      auth: {
        authorization: refreshToken, // Token in handshake
      },
    });

    socketRef.current = socket;

    socket.on('connection_successful', () => {
    });

    // Listen for order update
    socket.on('observe-menu', (data) => {
    });

    // Listen for order update
    socket.on('observe-menu-import', (data) => {
    });

    // Listen for scrapping progress
    socket.on('menu_progress', (data) => {

      setLoadProgress((prevProgress) => {
        if (prevProgress < data.progress) {
          return data.progress;
        } else return prevProgress;
      });
    });

    // Listen for scrapping finished
    socket.on('menu_finished', (data) => {

      if (data.fail) {
        setModalLoaderProgress(false);
        onScrapeFail();
        setLoadProgress(0);
      } else {
        setLoadProgress(100);
        triggerScrapping();
      }
    });

    socket.on('connect_error', (err) => {
      console.error('Connection Error:', err.message);
      console.error('Error Details:', err);
    });

    // Clean up on unmount
    return () => {
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshToken]); // Connect once when refreshToken is available

  const observeMenu = (brandTemplateId: string, subscribe: boolean) => {
    if (socketRef.current && socketRef.current.connected) {
      const data = {
        brandTemplateId,
        subscribe,
      };
      socketRef.current.emit('observe-menu', data);
    }
  };

  return { observeMenu };
};

export default useMenuScrappingSocket;
